import React, { useState } from "react";

const PaginarDocumentos = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const { totalRegistros, onGetNextPage, pageSize } = props;

    const getNextPage = (pageNumber) => {
        setCurrentPage(pageNumber);
        onGetNextPage(pageNumber);
    };


    const renderPaging = () => {
        let totalPages = 0;
        const pages = [];
        if (totalRegistros > pageSize) {
            totalPages = totalRegistros / pageSize;
            let d = totalPages - Math.floor(totalPages);
            totalPages = d > 0 ? Math.floor(totalPages) + 1 : Math.floor(totalPages);

            for (let i = 1; i <= totalPages; i++) {
                pages.push(<a key={`page_${i}`} className={`item ${i == currentPage ? ' index-page-selected' : ''}`} onClick={() => getNextPage(i)}>{i}</a>);
            }

            return (<>
                <table>
                    <tbody>
                        <tr><th colSpan="7">
                            <div className="ui right floated pagination menu">

                                {(1 < currentPage) && <a className="icon item" onClick={() => getNextPage(currentPage - 1)}>
                                    <i className="left chevron icon"></i>
                                </a>}
                                {pages.map(item => item)}
                                {(totalPages > currentPage) && <a className="icon item" onClick={() => getNextPage(currentPage + 1)}>
                                    <i className="right chevron icon"></i>
                                </a>}
                            </div>
                        </th>
                        </tr>
                    </tbody>
                </table>
            </>
            );
        }
        return (<table />);
    };



    return (<>
        {renderPaging()}
    </>)
};


export default PaginarDocumentos;